import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Vote.css";

const initialFaqs = [
  {
    id: "collections",
    q: "کالکشن دو زیرنویس چیست؟",
    a: "کالکشن دو زیرنویس یعنی برای یک فیلم یا سریال خاص، دو زیرنویس هماهنگ با هم (زیرنویس اول با زبان خارجی و دوم فارسی) توسط کاربران پیدا می‌شود و به‌عنوان مجموعه‌ای که با هم هماهنگی دارد ذخیره می‌گردد؛ همه کاربران می‌توانند از آن مجموعه استفاده کنند.",
  },
  {
    q: "آیا همه می‌توانند کالکشن دو زیرنویس بسازند؟",
    a: (
      <>
        بله، همه می‌توانند کالکشن دو زیرنویس بسازند. برای آشنایی بیشتر با این
        مفهوم به بخش{" "}
        <Link to="/vote/FAQs#collections" className="vote-faq-link">
          «کالکشن دو زیرنویس چیست؟»
        </Link>{" "}
        مراجعه کنید.
      </>
    ),
  },
  {
    q: "آیا زبان‌آموز می‌تواند خودش یک مجموعه ثبت کند و به آن رأی بدهد؟",
    a: "بله، می‌تواند این کار را انجام دهد؛ اما بعد از رأی آوردن و پیش از استخراج لغات و اصطلاحات، هماهنگی آن دو زیرنویس توسط کارشناسان بررسی می‌شود و پس از تأیید، لغات و اصطلاحات استخراج می‌شوند.",
  },
  {
    q: "فیلم‌ها و سریال‌هایی که با مجموعه‌های دو زیرنویس هماهنگ شده‌اند از کجا قابل دانلودند؟",
    a: (
      <>
        ربات تلگرامی{" "}
        <a
          href="https://t.me/twosubbot"
          target="_blank"
          rel="noopener noreferrer"
          className="vote-faq-link"
        >
          @twosubbot
        </a>{" "}
        لینک دانلود این سریال‌ها را گردآوری کرده است؛ کاربران می‌توانند هزاران
        فیلم و سریال را از طریق این ربات به‌صورت رایگان دانلود کنند.
      </>
    ),
  },
  {
    q: "درخواست استخراج لغات و اصطلاحات چیست؟",
    a: "هر کالکشن دو زیرنویس می‌تواند کاندید استخراج لغات و اصطلاحات باشد. با ثبت درخواست (رأی) برای آن، به این موضوع کمک می‌کنید که زیرنویس شماره ۱ آن برای پردازش اولویت بگیرد.",
  },
  {
    q: "آیا ثبت درخواست هزینه دارد؟",
    a: "خیر؛ ثبت درخواست رایگان است و فقط امتیاز اولویت‌بندی را افزایش می‌دهد.",
  },
  {
    q: "چرا برای هر کالکشن دو زیرنویس فقط یک درخواست ثبت می‌شود؟",
    a: "برای هر کاربر و هر کالکشن دو زیرنویس، فقط یک درخواست ثبت می‌شود تا امتیازدهی منصفانه بماند. برای کالکشن‌های دو-زیرنویس دیگری که به همان زیرنویس اشاره دارند هم می‌توانید درخواست ثبت کنید.",
  },
  {
    q: "پس از ثبت درخواست چه اتفاقی می‌افتد؟",
    a: "زیرنویس‌هایی که رأی بیشتری دارند در صف پردازش قرار می‌گیرند و پس از تکمیل، لغات و اصطلاحات آن‌ها در پخش‌کننده در دسترس قرار می‌گیرد.",
  },
  {
    q: "از کجا متوجه وضعیت درخواستم بشوم؟",
    a: "از بخش «درخواست‌های من» می‌توانید لیست و وضعیت هر درخواست را ببینید.",
  },
];

const VoteFAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <>
      <h3 className="vote-section-title">
        <i className="fas fa-circle-question"></i>
        سوالات متداول
      </h3>

      <div className="vote-faq-list">
        {initialFaqs.map((faq, idx) => (
          <div className="vote-faq-item" key={idx} id={faq.id || undefined}>
            <button
              className={`vote-faq-q ${openIndex === idx ? "open" : ""}`}
              onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
            >
              <i className="fas fa-question-circle"></i>
              {faq.q}
              <i className="fas fa-chevron-down vote-faq-toggle"></i>
            </button>
            {openIndex === idx && (
              <div className="vote-faq-a">{faq.a}</div>
            )}
          </div>
        ))}
      </div>

      <div className="vote-faq-note">
        این بخش به‌زودی با سوالات و پاسخ‌های بیشتر تکمیل می‌شود.
      </div>
    </>
  );
};

export default VoteFAQs;